export default {
  computed: {
    displayCitySelect() {
      return this.$store.getters['store/hasMultipleCities'];
    },
    citySelectProps() {
      return {
        props: {
          active: this.cityModalActive,
        },
        listeners: {
          'update:active': v => this.cityModalActive = v,
        },
      };
    }
  },
  data() {
    return {
      searchIsActive: false,
      cityModalActive: false,
    };
  },
};
